<div class="modal fade" id="kt_manage_deposits_client_account_modal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-xl p-9">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2 class="modal-title">Client Account</h2>
				<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross-square fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>

			<div class="modal-body">
				<div *ngIf="isLoading" class="text-center p-5">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
					<p class="mt-2">Loading client information...</p>
				</div>

				<div *ngIf="!isLoading && clientData">
					<h6 class="text-center fw-bold fs-7 text-uppercase bg-gray-300 p-3">Member Information</h6>
					<dl class="definition-list four-cols">
						<div class="def-item">
							<dt>Login ID</dt>
							<dd><strong>{{ clientData.email || '--' }}</strong></dd>
						</div>
						<div class="def-item">
							<dt>Address</dt>
							<dd>{{ clientData.address || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Company Name</dt>
							<dd>{{ clientData.company || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Name</dt>
							<dd>{{ (clientData.title ? clientData.title + ' ' : '') + (clientData.name || '--') }}</dd>
						</div>
						<div class="def-item">
							<dt>City</dt>
							<dd>{{ clientData.city || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>State</dt>
							<dd>{{ clientData.state || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Country</dt>
							<dd>{{ clientData.country || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Zip</dt>
							<dd>--</dd>
						</div>
						<div class="def-item">
							<dt>Telephone</dt>
							<dd>{{ clientData.phone || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Mobile</dt>
							<dd>{{ clientData.mobile || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Fax</dt>
							<dd>{{ clientData.fax || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Create Date</dt>
							<dd>{{ formatDate(clientData.created_at) }}</dd>
						</div>
						<div class="def-item">
							<dt>Status</dt>
							<dd>{{ clientData.status || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Sales Person</dt>
							<dd>{{ clientData.sales_person || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Rating</dt>
							<dd>{{ clientData.rating || '--' }}</dd>
						</div>
						<div class="def-item">
							<dt>Opening Balance</dt>
							<dd>{{ getOpeningBalanceDisplay() }}</dd>
						</div>
					</dl>
				</div>

				<div *ngIf="!isLoading && hasError" class="text-center p-5">
					<div class="alert alert-danger">
						<i class="ki-duotone ki-cross-circle fs-2x text-danger mb-3">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						<p class="mb-0">{{ errorMessage }}</p>
					</div>
				</div>

				<!-- <div *ngIf="!isLoading && !clientData && !hasError" class="text-center p-5">
					<p class="text-muted">No client data available</p>
				</div> -->
				<div class="total-amount">
					<div>Sale Amount: $ 58,745</div>
					<div>Payment Recieved: $ 19,689</div>
					<div>Opening Balance: $ 0 Dr.</div>
					<div>Balance: <span style="color:#F00"> $ 39,056</span></div>
					<div>
						<a href="#">
							<img src="/assets/media/xls.png" width="20px" height="20px" />
						</a>
					</div>
				</div>
				<div class="d-flex justify-content-center py-3">
					<button type="button" class="btn btn-sm btn-dark me-3" (click)="togglePaymentHistory()">
						<i class="ki-duotone ki-plus fs-2" *ngIf="!showPaymentHistory"></i>
						<i class="ki-duotone ki-minus fs-2" *ngIf="showPaymentHistory"></i>
						<span>Payment History</span>
					</button>
					<button type="button" class="btn btn-sm btn-dark me-3" (click)="toggleInvoiceHistory()">
						<i class="ki-duotone ki-plus fs-2" *ngIf="!showInvoiceHistory"></i>
						<i class="ki-duotone ki-minus fs-2" *ngIf="showInvoiceHistory"></i>
						<span>Invoice History</span>
					</button>
				</div>
				<div *ngIf="showPaymentHistory">
					<app-deposit-listing [customerId]="customerId"
						(depositSelected)="onDepositSelected($event)"></app-deposit-listing>
				</div>
				<div *ngIf="showInvoiceHistory">
					<app-invoice-listing [customerId]="customerId" [showAllocateAmount]="showAllocateAmount"
						(allocationChanged)="onAllocationChanged($event)"></app-invoice-listing>

				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-dark" data-bs-dismiss="modal">Close</button>
				<button type="button" class="btn btn-sm btn-primary">Save changes</button>
			</div>
		</div>
	</div>
</div>